import PageMeta from "../../../components/common/PageMeta";
import PageBreadcrumb from "../../../components/common/PageBreadCrumb";
import MemberkitTable from "../../../components/apps/memberkit/MemberkitTable";
import { useNavigate } from "react-router";

export default function Memberkit() {
    const navigate = useNavigate();

    // Função para voltar à página anterior
    const handleGoBack = () => {
        navigate(`/apps`);
    };

    return (
        <>
            <PageMeta
                title="Sellyo - Memberkit"
                description="Memberkit"
            />
            <PageBreadcrumb
                pageTitle="Memberkit"
                showBackButton={true}
                onBack={handleGoBack}
            />
            <div className="grid grid-cols-12 gap-4 md:gap-6">

                <div className="col-span-12 space-y-6">
                    <MemberkitTable />
                </div>
            </div>
        </>
    );
}